<template>
  <div
    class="relative w-full cursor-pointer p-2 rounded border border-bgr-300 text-sm font-semibold truncate"
    role="button"
  >
    <div
      class="absolute right-2 rounded-full h-7 w-7 border border-bgr-300 bg-bgr-200 top-1/2 -translate-y-1/2 flex items-center justify-center"
    >
      <WebccIcon name="site/edit" class="w-5 h-5" />
    </div>

    <div class="grid gap-1.5">
      <p class="text-sm">
        {{ model.destination?.label || $t(`${trPrefix}placeholders.where`) }}
      </p>

      <div
        class="grid grid-cols-1 gap-1.5 min-[420px]:flex min-[420px]:items-center min-[420px]:gap-2"
      >
        <p class="flex gap-2 items-center">
          <WebccIcon name="site/calendar" class="w-4 h-4" />
          <span class="text-xs">
            {{ tripDatesText || $t(`${trPrefix}placeholders.when`) }}
          </span>
        </p>

        <span class="h-4 w-[1px] bg-bgr-900 hidden min-[420px]:block"></span>

        <p class="flex gap-2 items-center">
          <WebccIcon name="site/pax" class="w-4 h-4" />
          <span class="text-xs">
            {{ $t(`${trPrefix}pax_s`, model.guests.pax) }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const trPrefix = 'www.components.elements.SearchBox.'

const model = defineModel<SearchBarState>({ required: true })

const tripDatesText = useDatesTripText(() => model.value.period)
</script>
